import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUtilities = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#e9e47c",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 11.75H7.25C6.45435 11.75 5.69129 11.434 5.12868 10.8713C4.56607 10.3087 4.25 9.54567 4.25 8.75002V6.49902C4.25 6.30011 4.32902 6.10935 4.46967 5.96869C4.61032 5.82804 4.80109 5.74902 5 5.74902H11C11.1989 5.74902 11.3897 5.82804 11.5303 5.96869C11.671 6.10935 11.75 6.30011 11.75 6.49902V8.74902C11.7501 9.14307 11.6726 9.53329 11.5219 9.89738C11.3712 10.2615 11.1503 10.5923 10.8717 10.871C10.5931 11.1497 10.2623 11.3707 9.89828 11.5216C9.53424 11.6724 9.14405 11.75 8.75 11.75Z",
			fill: "currentColor",
			fillOpacity: .3,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.75V14.75",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 5.75V1.25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 5.75V1.25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUtilities;
